export const blockCompare = (a, b) => {
    const blockOrder = ["ProductivePasture", "CutAndCarry", "ProductiveCrop", "ProductiveFruit", "FodderCrop", "NonProductiveRiparian", "NonProductiveWetland", "NonProductiveTreesAndScrub", "NonProductiveHouse"];
    return blockOrder.indexOf(a.value) > blockOrder.indexOf(b.value) ? 1 : -1;
};
